module.exports = __webpack_public_path__ + "static/media/pass_failed.a1aa19b2.svg";